import { Flex } from '@mantine/core'

import type { ManageBudgetsListProps } from '@/components/ManageBudgetsList/ManageBudgetsList.types'
import { ManageBudgetsListItem } from '@/components/ManageBudgetsListItem/ManageBudgetsListItem'
import { ScrollArea } from '@/components/ScrollArea/ScrollArea'

export function ManageBudgetsList({
  addBudgetToDelete,
  addEditedMonthlyAmount,
  budgets,
}: ManageBudgetsListProps) {
  return (
    <ScrollArea
      h={budgets.budgets.length > 5 ? 350 : 'auto'}
      mt={16}
      scrollbars="y"
    >
      <Flex direction="column" gap={8}>
        {budgets.budgets.map(budget => (
          <ManageBudgetsListItem
            key={budget.id}
            addBudgetToDelete={addBudgetToDelete}
            addEditedMonthlyAmount={addEditedMonthlyAmount}
            budget={budget}
          />
        ))}
      </Flex>
    </ScrollArea>
  )
}
